interface DevStationListType {
  [key: string]: {
    id: string;
  }
}

const DEV_STATIONS_LIST: DevStationListType = {
  'koth.localhost': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'koth.svp.edcar.pbs.org': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'koth.svp.beta.pbs.org': {
    id: 'f3842586-2c40-43fa-a79f-841fd5f2b9cb'
  },
  'watch.weta.localhost' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'weta.svp.edcar.pbs.org' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'weta.svp.beta.pbs.org' : {
    id: '92d89794-5ff0-4fe6-a443-cc888104e021'
  },
  'video.whut.localhost' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  'whut.svp.edcar.pbs.org' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  },
  'whut.svp.beta.pbs.org' : {
    id: '722b847a-5e2a-4d14-9429-2d430b10b1ee'
  }
}

export function isDevStation(hostname: string) {
  return DEV_STATIONS_LIST[hostname] != undefined
}

export function devStationId(hostname: string) {
  return DEV_STATIONS_LIST[hostname].id
}
